import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_BASE_URL;

class AdminPlanService {
  // Get all subscription plans
  async getAllPlans() {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/plans`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plans:', error);
      throw error;
    }
  }

  // Get plan by ID
  async getPlanById(planId) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/plans/${planId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching plan by ID:', error);
      throw error;
    }
  }

  // Create new plan
  async createPlan(planData) {
    try {
      const response = await apiClient.post(`${baseUrl}/admin/payments/plans`, planData);
      return response.data;
    } catch (error) {
      console.error('Error creating plan:', error);
      throw error;
    }
  }

  // Update plan
  async updatePlan(planId, planData) {
    try {
      const response = await apiClient.put(`${baseUrl}/admin/payments/plans/${planId}`, planData);
      return response.data;
    } catch (error) {
      console.error('Error updating plan:', error);
      throw error;
    }
  }

  // Delete plan
  async deletePlan(planId) {
    try {
      const response = await apiClient.delete(`${baseUrl}/admin/payments/plans/${planId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting plan:', error);
      throw error;
    }
  }

  // Toggle plan status
  async togglePlanStatus(planId) {
    try {
      const response = await apiClient.patch(`${baseUrl}/admin/payments/plans/${planId}/toggle-status`);
      return response.data;
    } catch (error) {
      console.error('Error toggling plan status:', error);
      throw error;
    }
  }
}

export default new AdminPlanService();
